import { render, staticRenderFns } from "./itemCategory.vue?vue&type=template&id=a998bfc8&scoped=true&"
import script from "./itemCategory.vue?vue&type=script&lang=js&"
export * from "./itemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a998bfc8",
  null
  
)

export default component.exports